import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kp-permission-dialog',
  templateUrl: './permission-dialog.component.html',
  styleUrls: ['./permission-dialog.component.scss'],
})
export class PermissionDialogComponent {
  @Input() canEnable = false;
  @Input() description: string;
  @Output() enableButtonClicked = new EventEmitter();

  enableNotifications() {
    this.enableButtonClicked.emit();
  }
}
